import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { InvoiceDetailPage } from '@/features/billing/invoices-pages';
import { INVOICE_TABS, type InvoiceTab } from '@/features/billing/billing-shared';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'une facture (lot L01). L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/billing/invoices/$invoiceId')({
  validateSearch: (search: Record<string, unknown>): { tab: InvoiceTab } => ({
    tab: INVOICE_TABS.parse(search['tab']),
  }),
  component: InvoiceRoute,
});

function InvoiceRoute() {
  const { tenant, invoiceId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="invoices"
      crumbs={[{ label: t('nav.items.invoices') }, { label: invoiceId, mono: true }]}
    >
      <InvoiceDetailPage
        tenantId={tenant}
        invoiceId={invoiceId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
